const ActionButton = ({ Icon, label, bgColor, hoverColor, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`w-full ${bgColor} hover:${hoverColor} text-white px-4 py-2 rounded-lg transition-colors flex items-center justify-center space-x-2 cursor-pointer`}
    >
      <Icon className="w-4 h-4" />
      <span>{label}</span>
    </button>
  );
};

export default ActionButton;
